const Features = [
	{
		id: '1',
		heading: 'Activities',
		body: 'Build Immersive experiences where users can instantly play, listen and learn together',
		img: 'activities-img.svg',
	},
	{
		id: '2',
		heading: 'Game Integration',
		body: 'Integrate Game SDK with your games ta create thrilling user experiences for your players on DevAsks',
		img: 'game-integration-img.svg',
	},
	{
		id: '3',
		heading: 'Personalized Views',
		body: 'Allows users display what they are currently playing, watching or viewing in their profile on DevAsk',
		img: 'personalized-views.svg',
	},
	{
		id: '4',
		heading: 'Connections',
		body: 'Users can collaborate to Build Anything on DevAsk',
		img: 'connection-img.svg',
	},
];

export default Features;
